import React, { useState } from "react";

/* ===========================
   Common Reusable Table with Checkbox
=========================== */
const CommonTableCheckbox = ({ columns, data, renderActions, onSelectionChange }) => {
  const [selectedRows, setSelectedRows] = useState([]); // store IDs

  const isAllSelected = data.length > 0 && selectedRows.length === data.length;

  // Toggle single row
  const toggleRow = (row) => {
    const exists = selectedRows.includes(row.id);
    let updated;

    if (exists) {
      updated = selectedRows.filter((id) => id !== row.id);
    } else {
      updated = [...selectedRows, row.id];
    }

    setSelectedRows(updated);
    onSelectionChange && onSelectionChange(updated);
  };

  // Toggle select all
  const toggleAll = () => {
    const updated = isAllSelected ? [] : data.map(row => row.id);
    setSelectedRows(updated);
    onSelectionChange && onSelectionChange(updated);
  };

  return (
    <table className="w-full">
      <thead className="bg-gray-50 border-b">
        <tr>
          <th className="px-4 py-3 text-left">
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={toggleAll}
            />
          </th>

          {columns.map((col) => (
            <th
              key={col.key}
              className="px-4 py-3 text-left text-sm font-medium textblack"
            >
              {col.label}
            </th>
          ))}

          {renderActions && (
            <th className="px-4 py-3 text-sm font-medium textblack text-left">
              Action
            </th>
          )}
        </tr>
      </thead>

      <tbody>
        {data.map((row, index) => {
          let checked = selectedRows.includes(row.id);

          return (
            <tr
              key={index}
              className="border-b last:border-none hover:bg-gray-50"
            >
              <td className="px-4 py-4">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggleRow(row)}
                />
              </td>

              {columns.map((col) => (
                <td key={col.key} className="px-6 py-4 text-sm text-[#111827]">
                  {col.key === "status" ? (
                    <span
                      className={`px-4 w-28 mx-auto text-center py-2 rounded-md text-sm font-medium inline-block
                        ${row[col.key] === "Completed"
                          ? "bg-[#E0F2F1] textcolor"
                          : "border border-[#14B8A6] textcolor"
                        }`}
                    >
                      {row[col.key]}
                    </span>
                  ) : (
                    row[col.key]
                  )}
                </td>
              ))}

              {renderActions && (
                <td className="px-4 py-2">
                  {renderActions(row)}
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default CommonTableCheckbox;
